import type { Verdict } from "@patent-studio/api-types";
import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { VERDICT_LABELS } from "@/lib/verdict-labels";

/**
 * Which verdicts a yes has to be warned about first. Keyed by the served type
 * so a verdict added to the enum has to say here whether it is adverse.
 */
const WARNED: Record<Verdict, boolean> = {
  novel: false,
  partially_novel: true,
  not_novel: true,
  not_assessed: false,
};

export function warnsBeforeConfirming(verdict: Verdict): boolean {
  return WARNED[verdict];
}

/**
 * The warning before a yes against the tool's advice. Two choices and no
 * third: cancel leaves the position unconfirmed and unchanged, confirm anyway
 * confirms it. A position marked adverse never reaches a confirmed state
 * without this having been shown and acknowledged.
 */
export function ConfirmAgainstAdvice({
  verdict,
  onCancel,
  onConfirm,
}: {
  verdict: Verdict;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <ConfirmDialog
      open
      title={`Confirm a position marked "${VERDICT_LABELS[verdict]}"?`}
      description="The prior art already reaches this position, so confirming it as it stands may not yield a novel claim. The exposure travels forward into the claim strategy."
      actionLabel="Confirm anyway"
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
